const faker = require("faker");

const fakeSentece = (len) => faker.lorem.sentence(len);
const fakeTime = (max) => faker.datatype.number(max);

module.exports = {
  fakeSentece,
  fakeTime,
};
